import { allPackagedInsightScope } from "../constants/filters";
import { IHubContentType } from "../types/ihubContentType";
import { InsightDeckTemplateTheme } from "../types/providers";

export const UNIVERSAL_VIEW_CONFIG = {
    allowedContentTypes: {
        [IHubContentType.INSIGHTS]: {
            enabled: true,
            allowedTemplateTypes: [
                allPackagedInsightScope.value,
                InsightDeckTemplateTheme.AD_PRODUCTS,
                InsightDeckTemplateTheme.ADVERTISER_GOALS,
                InsightDeckTemplateTheme.DOWNSTREAM_IMPACT,
                InsightDeckTemplateTheme.INDUSTRY_INSIGHTS,
                InsightDeckTemplateTheme.SEASONAL_EVENTS,
            ],
            defaultMessage: "This insight type requires an account selection",
        },
        [IHubContentType.MARKETING_CONTENT]: {
            enabled: true,
        },
    },
} as const;

export type UniversalViewContentType =
    keyof typeof UNIVERSAL_VIEW_CONFIG.allowedContentTypes;
